import { ChangeDetectorRef } from '@angular/core';
import { LayoutRouterOutletFullscreenComponent } from '@common/layout/frontend-shared/router-outlet-fullscreen';
import { LayoutSidebarComponent, LayoutSidebarWrapperComponent } from '@common/layout/frontend-shared/sidebar';
import { FeatureMenuItemService } from '@core/frontend-shared/feature';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared/feature";
export let CoreManagementComponent = /*#__PURE__*/(() => {
  class CoreManagementComponent {
    constructor(featureMenuItemService, cd) {
      featureMenuItemService.getAccessibleMenuItems('managementToolbar').pipe(takeWhileAlive()).subscribe(menuItems => {
        this.menuModel = [];
        menuItems.forEach(menuItem => {
          this.menuModel.push(menuItem);
        });
        cd.markForCheck();
      });
    }
    static {
      this.ɵfac = function CoreManagementComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreManagementComponent)(i0.ɵɵdirectiveInject(i1.FeatureMenuItemService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreManagementComponent,
        selectors: [["core-management"]],
        decls: 7,
        vars: 2,
        consts: [[1, "content"], [1, "content-inner"], [3, "menuModel", "expandAll"], [1, "title"]],
        template: function CoreManagementComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "layout-sidebar-wrapper")(1, "div", 0)(2, "div", 1);
            i0.ɵɵelement(3, "router-outlet-fullscreen");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "layout-sidebar", 2)(5, "h4", 3);
            i0.ɵɵtext(6, "Verwaltung");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("menuModel", ctx.menuModel)("expandAll", true);
          }
        },
        dependencies: [LayoutSidebarComponent, LayoutSidebarWrapperComponent, LayoutRouterOutletFullscreenComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex:1}.toolbar[_ngcontent-%COMP%]{min-width:250px;background:var(--contentColor);border-top:1px solid var(--backgroundSoftColor)}.toolbar[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{padding:20px 15px;margin:0}.toolbar[_ngcontent-%COMP%]   .btn-logout[_ngcontent-%COMP%]{margin:10px 0 20px 15px}.content[_ngcontent-%COMP%]{flex:1;display:flex}.content-inner[_ngcontent-%COMP%]{flex:1;position:relative}.content-inner[_ngcontent-%COMP%]{border:20px solid var(--backgroundSoftColor);background:var(--backgroundSoftColor)}[_nghost-%COMP%]     .layout-main{display:flex}"],
        changeDetection: 0
      });
    }
  }
  return CoreManagementComponent;
})();